module.exports = __webpack_public_path__ + "img/app-3d.96a398a1.png";